import React from 'react';
import classNames from 'classnames';

const TEXT_STYLES = {
  font_weight: { activeValue: 'bold', inactiveValue: 'normal', defaultActive: true },
  font_style: { activeValue: 'italic', inactiveValue: 'normal' },
  text_decoration: { activeValue: 'underline', inactiveValue: 'none' },
  strike_through: { activeValue: 'line-through', inactiveValue: 'none' },
};

const TextStyleSettings = ({ onChange, ...props }) => {
  const isActive = (name) => {
    const field = props[name];
    if (!field) return false;
    const { activeValue, defaultActive } = TEXT_STYLES[name];
    return field.value === activeValue || (defaultActive && field.value === undefined);
  };

  const toggle = (name) => {
    const field = props[name];
    if (!field) return;
    const { activeValue, inactiveValue } = TEXT_STYLES[name];
    const newValue = isActive(name) ? inactiveValue : activeValue;
    onChange(field.field, newValue);
  };

  return (
    <div className="btn-group btn-group-block">
      {Object.keys(TEXT_STYLES).map((name) => (
        props[name] && (
          <button
            key={name}
            className={classNames('btn btn-form fantastic-sidebar__settings-btn', { active: isActive(name) })}
            onClick={() => toggle(name)}
            type="button"
          >
            <i className={`fi fi-${name.replace(/_/g, '-')}`}></i>
          </button>
        )
      ))}
    </div>
  );
};

export default TextStyleSettings;
